export default __webpack_public_path__ + "static/media/_ic_arrow_up.ccace810.svg";